import { put, select, takeLatest, call } from 'redux-saga/effects'
import { ConfigurationsConstants } from '../../../configurations/store/configurations.constants'
import { IServiceConfig } from '../../../configurations/store/configurations.types'
import { getServiceConfigSelector } from '../../../configurations/selectors/serviceConfig.selector'
import sessionResumeService from '../service/sessionResume.service'
import { store } from '../../../../index'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { CrewService } from '../../../crew/services/crew.service'
import { IClientDataDoc } from '../../../../services/clientData.service'
import { getServiceIdSelector } from '../../../user/selectors/getServiceId.selector'
import { ICrewListMember } from '../../../pcr/models/crewList.V1'
import { getUserSelector } from '../../../user/selectors/getUser.selector'
import { IUserState } from '../../../user/store/user.types'
import { resetSession, setUser } from '../store/sessionResume.actions'
import { isResumeSessionEnabled } from '../utils/sessionResume.util'
import { DISABLE_SESSION_TIMEOUT } from '../store/sessionResume.constants'
import Logger from '../../../../services/logger.service'
import { getSessionResumeSelector } from '../store/sessionResume.selectors'
import { getPcrIdSelector } from '../../../home/selectors/getPcrId.selector'
import { isSessionPersistenceEnabled, isSessionResumeInitialState } from '../../persist/utils/sessionPersist.util'
import { sessionPersistService, IPersistedMetadata } from '../../persist/service/sessionPersist.service'
import { getRouterHistory } from '../../../../utilities/navigation.util'

export function* sessionResume() {
  try {
    if (!isResumeSessionEnabled()) {
      sessionResumeService.stopSession()
      yield put(resetSession())
      return
    }

    const serviceId: string = yield select(getServiceIdSelector)
    const user: IUserState = yield select(getUserSelector)

    const crewService = new CrewService(serviceId)
    const serviceUsers: IClientDataDoc = yield call([crewService, crewService.getCrewList])
    const userObj = serviceUsers.entity.find((u: ICrewListMember) => Number(u.userId) === Number(user.userId))

    if (userObj) {
      yield put(setUser({ ...userObj, authState: user.authState }))
    }

    if (isSessionPersistenceEnabled()) {
      try {
        const sessionResumeState = yield select(getSessionResumeSelector)
        const pcrId: string | undefined = yield select(getPcrIdSelector)
        const sessionUser = sessionResumeState.user

        if (sessionUser && !isSessionResumeInitialState(sessionUser) && sessionUser.authState) {
          const history = getRouterHistory()
          const metadata: IPersistedMetadata = {
            user: sessionUser,
            currentRoutePath: history?.location?.pathname || window.location.pathname,
            pcrId,
            timestamp: Date.now(),
          }
          yield call([sessionPersistService, sessionPersistService.saveMetadata], metadata)
          Logger.info('[SessionPersist] Metadata saved at service selection')
        }
      } catch (error) {
        Logger.warn(`[SessionPersist] Failed to save metadata at service selection: ${error}`)
      }
    }

    const serviceConfig: IServiceConfig = yield select(getServiceConfigSelector)
    const { SESS_TIMEOUT } = serviceConfig

    if (sessionResumeService.isRunning) return
    if (SESS_TIMEOUT === DISABLE_SESSION_TIMEOUT) return

    sessionResumeService.initialize(store.dispatch, SESS_TIMEOUT as number)
    sessionResumeService.startSession()
    Logger.info('[SESSION_TIMEOUT] Session started')
  } catch (e) {
    yield put(throwPcrException(`sessionResume() error: ${e}`))
  }
}

export function* sessionResumeSaga() {
  yield takeLatest([ConfigurationsConstants.SET_SERVICE_CONFIG], sessionResume)
}
